import { cn } from "@/lib/utils";
import { GENERIC_STATUS, PRIORITY, SLA_STATE } from "@/lib/constants";

export function StatusBadge({ status, map = GENERIC_STATUS, className, testId }) {
  const m = map[status] || { label: status || "—", cls: "bg-slate-500/10 text-slate-500 border-slate-500/20" };
  return (
    <span data-testid={testId} className={cn("inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-mono font-medium whitespace-nowrap", m.cls, className)}>
      {m.label}
    </span>
  );
}
export const PriorityBadge = ({ priority, testId }) => <StatusBadge status={priority} map={PRIORITY} testId={testId} />;
export const SlaBadge = ({ state, testId, className }) => (
  <StatusBadge status={state} map={SLA_STATE} testId={testId} className={cn(state === "breached" && "animate-pulse", className)} />
);
